"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var validation_error_1 = require("./validation_error");
exports.verify = function (spec, value, globalOptions) {
    if (globalOptions === void 0) { globalOptions = {}; }
    try {
        var result_1 = spec.eval(value, { global: globalOptions });
        return {
            err: null,
            value: function () { return result_1; }
        };
    }
    catch (err) {
        if (err instanceof validation_error_1.ValidationError) {
            var validationError_1 = err;
            return {
                err: validationError_1,
                value: function () { throw validationError_1; }
            };
        }
        throw err;
    }
};
exports.alias = function (aliasName, spec) {
    return {
        definition: __assign({}, spec.definition, { alias: aliasName }),
        eval: spec.eval
    };
};
var removeAlias = function (specDef) {
    var def = __assign({}, specDef);
    delete def.alias;
    return def;
};
exports.constrain = function (spec, constraints) {
    return {
        definition: __assign({}, removeAlias(spec.definition), { constraints: (spec.definition.constraints || []).concat(constraints.map(function (c) { return c.definition; })) }),
        eval: function (value, options) {
            var candidateResult = spec.eval(value, options);
            constraints.forEach(function (c) { return c.eval(candidateResult); });
            return candidateResult;
        }
    };
};
exports.optional = function (spec) {
    return {
        definition: __assign({}, spec.definition, { flags: ["optional"] }),
        eval: spec.eval,
        optional: true
    };
};
exports.adjust = function (spec, adjustedOptions) {
    return {
        definition: __assign({}, removeAlias(spec.definition), { adjustments: __assign({}, adjustedOptions, spec.definition.adjustments) }),
        eval: function (value, options) {
            return spec.eval(value, { local: __assign({}, adjustedOptions, options.local), global: options.global });
        }
    };
};
exports.definitionOf = function (spec) {
    return spec.definition;
};
var _extractAliases = function (def, aliases) {
    var aliasedDefinition = __assign({}, def, (def.nested ? { nested: Object.keys(def.nested).reduce(function (o, k) {
            var nt = def.nested[k];
            o[k] = _extractAliases(nt, aliases);
            return o;
        }, {}) } : {}));
    if (def.alias) {
        aliases[def.alias] = aliasedDefinition;
        return { alias: def.alias };
    }
    else {
        return aliasedDefinition;
    }
};
exports.extractAliases = function (def) {
    var aliases = {};
    return {
        definition: _extractAliases(def, aliases),
        aliases: aliases
    };
};
exports.either = function (spec1, spec2, spec3, spec4, spec5, spec6, spec7, spec8, spec9) {
    var nested = {
        1: spec1.definition,
        2: spec2.definition
    };
    if (spec3) {
        nested[3] = spec3.definition;
    }
    if (spec4) {
        nested[4] = spec4.definition;
    }
    if (spec5) {
        nested[5] = spec5.definition;
    }
    if (spec6) {
        nested[6] = spec6.definition;
    }
    if (spec7) {
        nested[7] = spec7.definition;
    }
    if (spec8) {
        nested[8] = spec8.definition;
    }
    if (spec9) {
        nested[9] = spec9.definition;
    }
    return {
        definition: {
            type: "either",
            nested: nested
        },
        eval: function (value, options) {
            var validationErrors = [];
            var resultSpec1 = exports.verify(spec1, value, options.global);
            if (resultSpec1.err) {
                validationErrors.push(resultSpec1.err);
            }
            else {
                return resultSpec1.value();
            }
            var resultSpec2 = exports.verify(spec2, value, options.global);
            if (resultSpec2.err) {
                validationErrors.push(resultSpec2.err);
            }
            else {
                return resultSpec2.value();
            }
            if (spec3) {
                var resultSpec3 = exports.verify(spec3, value, options.global);
                if (resultSpec3.err) {
                    validationErrors.push(resultSpec3.err);
                }
                else {
                    return resultSpec3.value();
                }
            }
            if (spec4) {
                var resultSpec4 = exports.verify(spec4, value, options.global);
                if (resultSpec4.err) {
                    validationErrors.push(resultSpec4.err);
                }
                else {
                    return resultSpec4.value();
                }
            }
            if (spec5) {
                var resultSpec5 = exports.verify(spec5, value, options.global);
                if (resultSpec5.err) {
                    validationErrors.push(resultSpec5.err);
                }
                else {
                    return resultSpec5.value();
                }
            }
            if (spec6) {
                var resultSpec6 = exports.verify(spec6, value, options.global);
                if (resultSpec6.err) {
                    validationErrors.push(resultSpec6.err);
                }
                else {
                    return resultSpec6.value();
                }
            }
            if (spec7) {
                var resultSpec7 = exports.verify(spec7, value, options.global);
                if (resultSpec7.err) {
                    validationErrors.push(resultSpec7.err);
                }
                else {
                    return resultSpec7.value();
                }
            }
            if (spec8) {
                var resultSpec8 = exports.verify(spec8, value, options.global);
                if (resultSpec8.err) {
                    validationErrors.push(resultSpec8.err);
                }
                else {
                    return resultSpec8.value();
                }
            }
            if (spec9) {
                var resultSpec9 = exports.verify(spec9, value, options.global);
                if (resultSpec9.err) {
                    validationErrors.push(resultSpec9.err);
                }
                else {
                    return resultSpec9.value();
                }
            }
            throw new validation_error_1.ValidationError("Evaluation of value failed for every possible spec.", {
                nestedErrors: validationErrors
            });
        }
    };
};
//# sourceMappingURL=spec.js.map